<template>
  <div class="login-page">
    <div class="row">
      <div class="sm-12 md-6 lg-5 md-centered text-center" v-if="appLoading">
        <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
      </div>
      <div class="sm-12 md-6 lg-5 md-centered" v-else>
        <form @submit.stop.prevent="login">
          <label>
            <CPFInput
              v-model="cpf"
              placeholder="E-mail, CPF ou CNPJ"
              required></CPFInput>
          </label>
          <label>
            <PasswordInput
              class="password-input"
              v-model="senha"
              placeholder="Senha"
              requried />
          </label>
          <button type="submit" class="button primary" disabled v-if="loading">
            <i class="mdi mdi-spin mdi-loading"></i>
          </button>
          <button type="submit" class="button primary" v-else>ENTRAR</button>
          <p>
            Ao clicar em entrar, você concorda com a nossa <br />
            <a :href="url_politica" target="_blank">POLÍTICA DE PRIVACIDADE</a>.
          </p>
        </form>
        <div class="links">
          <router-link to="/login/esqueci-minha-senha"
            >Esqueci minha senha</router-link
          >
          <router-link to="/login/primeiro-acesso">Primeiro Acesso</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "/plugins/api";
import CPFInput from "/components/CPFInput.vue";
import PasswordInput from "/components/PasswordInput.vue";
import Swal from "sweetalert2";

export default {
  components: {
    CPFInput,
    PasswordInput,
  },
  data() {
    return {
      cpf: process.env.USERNAME,
      senha: process.env.PASSWORD,
      loading: false,
    };
  },
  computed: {
    appLoading() {
      return this.$store.state.loading;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    empresa() {
      return this.$store.state.empresa;
    },
    url_politica() {
      let dominio = "https://" + this.empresa.domain;
      return `${dominio}/politica-de-privacidade`;
    },
  },
  methods: {
    async login() {
      try {
        const cpf = this.cpf;
        const senha = this.senha;
        this.loading = true;

        let {
          data: { refresh_token, jwt, expiresAt },
        } = await api.post("auth/signin", { cpfCnpj: cpf, senha });

        await Promise.all([
          this.$store.dispatch("setRefreshToken", refresh_token),
          this.$store.dispatch("setJwt", jwt),
          this.$store.dispatch("setExpiresAt", expiresAt),
        ]);
        await this.$store.dispatch("loadDadosCliente");
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.replace(this.$route.query.redirect);
        } else {
          this.$router.replace("/");
        }
        /*
                return;

                let {cliente, relacoes} = await BuscaRelacaoCliente(cpf, senha);                        

                await Promise.all([
                    this.$store.dispatch('setCliente', cliente),
                    this.$store.dispatch('setRelacoes', relacoes)
                ]);            
                */
      } catch (err) {
        if (err.response && err.response.data) {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: err.response.data.error,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Não foi possível efetuar o login.",
          });
          console.error(err);
        }
        //alert(err.message);
      }
      this.loading = false;
    },
  },
  watch: {
    isAuthenticated(value) {
      if (value) {
        if (this.$route.query && this.$route.query.redirect) {
          //this.$router.replace(this.$route.query.redirect);
        } else {
          //this.$router.replace("/");
        }
        //this.$router.replace("/");
      }
    },
  },
};
</script>
<style scoped lang="less">
label {
  padding-bottom: 2px;
}
input {
  height: 55px;
  margin: 0;
}

p {
  color: var(--light-grey);
  a {
    color: var(--light-grey);
    text-decoration: underline;
  }
}

.login-page {
  .links {
    a {
      color: white;
    }
  }
}

</style>
